<app-content-page-layout title="Settings">
  @if(username) {
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <h2 class="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-4">Account</h2>
      <div class="flex flex-col gap-4">
        <div>
          <p class="text-xs text-gray-400 mb-0.5">Username</p>
          <p class="text-gray-800 font-medium">{{ username }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-400 mb-0.5">User ID</p>
          <p class="text-gray-800 font-medium">{{ userId }}</p>
        </div>
      </div>
    </div>
  } @else {
    <p class="text-gray-400 text-sm">Loading account information...</p>
  }
</app-content-page-layout>